import React from 'react';
import Automations from '../Automations/Automations';

function GridBot() {
  return <Automations openType="grid" />;
}

export default GridBot;